import {
  getRentalPropertyDetail,
  getRentalPropertyList,
} from '@apis/rental-property';
import DataHookFactory from '@templates/DataHookFactory';
import { IMedia } from 'interface/medias';
import { IDataList } from 'interface/pagination';
import {
  IRentalProperty,
  IRentalPropertyQuery,
} from 'interface/RentalProperty';

export enum SNSType {
  Youtube = 'Youtube',
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Instagram = 'Instagram',
  ExternalURL = 'ExternalURL',
}

export type ISNS = {
  type: SNSType;
  source: string;
};

export type RentalPropertyDetail = {
  id: string;
  name: string;
  description: string;
  quantity: number;
  bookingPrice: number;
  extraAdultPrice: number;
  extraChildrenPrice: number;
  rentalGap: number;
  medias: IMedia[];
  sns: ISNS[];
};

export const useRentalProperty = DataHookFactory<IDataList<IRentalProperty>>(
  async (payload: IRentalPropertyQuery) => {
    const resp = await getRentalPropertyList(payload);
    if (resp.status !== 200) throw new Error('Get rentalProperty list failed');
    return resp.data;
  },
  {
    autoFetch: true,
    minimumInterval: 5000,
  },
);

const useRentalPropertyDetail = DataHookFactory<RentalPropertyDetail>(
  async (id: string) => {
    if (!id) throw new Error('Invalid Id');
    const resp = await getRentalPropertyDetail(id);

    if (resp.status !== 200) throw new Error('Get map config failed');

    return resp.data;
  },
  {
    autoFetch: true,
    minimumInterval: 5000,
  },
);

export default useRentalPropertyDetail;
